import {getData,postData} from '@/assets/js/api.js';

//获取天幕方案
export const FindTianmuPlanList = (params,fn) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/find/page';
	return postData(methods, params, 1, fn);
};

//场景库
export const planSceneLib = (params,fn,cparameter) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/planSceneLib';
	return getData(methods, params, 1, fn,cparameter);
};

//场景库
export const saveCustomPlan = (params,fn,cparameter) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/save/custom';
	return postData(methods, params, 1, fn,cparameter);
};


//计算获取方案
export const compute = (params,fn) => {
	let methods = '/compute/compute';
	return postData(methods, params, 1, fn);
};

// 校验圆形线型灯阵列布局
export const verifyArrayLayout = (params,fn) => {
	let methods = '/compute/verify_array_layout';
	return postData(methods, params, 1, fn);
};

// 计算获取方案
export const points_to_matrix = (params,fn) => {
	let methods = '/compute/points_to_matrix';
	return postData(methods, params, 1, fn);
};



//保存方案
export const save = (params,fn) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/save';
	return postData(methods, params, 1, fn);
};

//根据长度和宽度获取光源密度范围
//https://iot-dev.opple.com/compute/get_density
export const getLightDensityRange = (params,fn) => {
	let methods = '/compute/get_density';
	return postData(methods, params, 1, fn);
}

//根据最小密度150mm，得到N，获取最大的长和宽范围
export const getMaxLength = (params,fn) => {
	let methods = '/compute/get_max_length';
	return getData(methods, params, 1, fn);
}

export const PostShare = (params,fn) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/share/to';
	return postData(methods, params, 1, fn);
};


export const FindShareList = (params,fn) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/share/find';
	return getData(methods, params, 1, fn);
};


export const PostRecieve = (params,fn) => {
	let methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/share/recieve';
	return postData(methods, params, 1, fn);
};

export const GetDevicesByPlanId = (params,fn) => {
	let methods = `/api/SkyCanvas/GetDevicesByPlanId`;
	return postData(methods, params, 1, fn);
};

export const AddSkyVirtualDevice = (params,fn) => {
	let methods = `/api/SkyCanvas/AddSkyVirtualDevice`;
	return postData(methods, params, 1, fn);
};

export const EditSkySubDevice = (params,fn) => {
	let methods = `/api/SkyCanvas/EditSkySubDevice`;
	return postData(methods, params, 1, fn);
};

export const deletePlan = (params,fn) => {
	let methods = `/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/delete`;
	return postData(methods, params, 1, fn);
};

export const getAllSceneList = (params,fn) => {
	let methods = `/gateway/sdlroutefront/sdlfront/sdltool/light/operation/wellsky/scene/find/page/skyCanvas`;
	return getData(methods, params, 1, fn);
};

export const getRgbByPoint = (params,fn) => {
	let methods = '/compute/image_to_lights_rgb';
	return postData(methods, params, 1, fn);
}

export const getCxCyByRgbs = (params,fn) => {
	let methods = '/compute/rgb_to_cxcy';
	return postData(methods, params, 1, fn);
}

///sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/findByPlanId
export const findByPlanId = (params,fn) => {
	let methods = `/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/findByPlanId`;
	return getData(methods, params, 1, fn);
};

export const findTianmuPlanListSimple = (params,fn) => {
	let methods = `/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/find/simple/page`;
	return postData(methods, params, 1, fn);
};

//创建或者重试创建视频场景点位数据接口
export const CreateSceneBin = (params,fn) => {
	let methods = '/api/scene/CreateSceneBin';
	return postData(methods, params, 1, fn);
};

//删除天幕视频场景，并更新转码状态

export const DeleteSceneBin = (params,fn) => {
	let methods = '/api/scene/DeleteSceneBin';
	return postData(methods, params, 1, fn);
};

//获取场景点位数据
export const ReSyncConfig = (params,fn) => {
	let methods = '/api/scene/ReSyncConfig';
	return getData(methods, params, 1, fn);
};

//删除天幕模板 [新增加接口]
// api/SkyCanvas/DeleteSkyTemplate
export const DeleteSkyTemplate = (params,fn) => {
	let methods = '/api/SkyCanvas/DeleteSkyTemplate';
	return postData(methods, params, 1, fn);
};

